import uri from 'urijs';

/* @ngInject */
export default function BarGraphPanelService($sails, $filter) {
  const service = this;

  service.getData = getData;
  service.exportData = exportData;

  async function getData(eqId, startDate, endDate, value, eventName) {
    const URI = uri(`/event/values/${eqId}`).query({
      start: startDate.getTime(),
      end: endDate.getTime(),
      value,
      eventName
    });
    const events = await $sails.get(URI.toString());
    return events.data;
  }

  async function exportData(equipment, startDate, endDate, prettyNames) {
    const query = {
      start: startDate.getTime(),
      end: endDate.getTime(),
      // value, // added later
      // eventName
    };

    const eqAllArray = await Promise.all(_.map(equipment, async ({ id, name, values, eventName }) => {
      const valAllArray = await Promise.all(_.map(values, async (value) => {
        const URI = uri(`/event/values/${id}`).query(_.assign({}, query, { value, eventName })); // assign & clone
        const { data } = await $sails.get(URI.toString());
        const rows = _.map(data, ([timestamp, reading]) => {
          const prettyName = _.get(prettyNames, [id, value], value);
          const date = $filter('date')(new Date(timestamp), 'short');

          return `${name},${prettyName},${date},${reading}`;
        });
        return rows.join('\n');
      }));
      return _.compact(valAllArray).join('\n');
    }));
    eqAllArray.unshift('Equipment,Point,Date,Value');

    return _.compact(eqAllArray).join('\n');
  }
}
